// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.re-onb {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1045;
  width: min(380px, calc(100vw - 24px));
  font-family: inherit;
  color: #182230;
}

.re-onb * {
  box-sizing: border-box;
}

.re-onb-launcher,
.re-onb-hide,
.re-onb-check,
.re-onb-go,
.re-onb-textbtn,
.re-onb-later-toggle {
  font: inherit;
  cursor: pointer;
}

.re-onb-launcher {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  border-radius: 999px;
  padding: 10px 14px 10px 10px;
  background: #155dfc;
  color: #fff;
  box-shadow: 0 10px 28px rgba(21, 93, 252, 0.28);
}

.re-onb-launcher-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  display: grid;
  place-items: center;
  flex: 0 0 auto;
}

.re-onb-launcher-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
}

.re-onb-launcher-copy strong {
  font-size: 13px;
  font-weight: 700;
}

.re-onb-launcher-copy span {
  font-size: 11px;
  opacity: 0.88;
}

.re-onb-hint,
.re-onb-card {
  background: #fff;
  border: 1px solid #e4eaf0;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(24, 34, 48, 0.14);
}

.re-onb-card .re-onb-hint {
  box-shadow: none;
  background: #f4f7ff;
  border-color: #d9e4fb;
}

.re-onb-hint {
  margin-bottom: 10px;
  padding: 14px 14px 12px;
}

.re-onb-hint-kicker {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #155dfc;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.re-onb-hint h3 {
  margin: 0 0 6px;
  font-size: 15px;
  line-height: 1.3;
}

.re-onb-hint p,
.re-onb-step p,
.re-onb-success p {
  margin: 0;
  color: #5d6b7b;
  font-size: 13px;
  line-height: 1.45;
}

.re-onb-hint-actions,
.re-onb-card-foot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.re-onb-textbtn {
  border: 0;
  background: transparent;
  color: #5d6b7b;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 2px;
}

.re-onb-textbtn.primary {
  color: #155dfc;
}

.re-onb-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 10px;
}

.re-onb-card-head h2 {
  margin: 0;
  font-size: 16px;
  line-height: 1.25;
}

.re-onb-card-head p {
  margin: 2px 0 0;
  color: #5d6b7b;
  font-size: 12px;
}

.re-onb-iconbtn {
  border: 0;
  background: #f3f6f8;
  color: #3b4c5b;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  cursor: pointer;
  flex: 0 0 auto;
}

.re-onb-progress {
  padding: 0 14px 8px;
}

.re-onb-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 700;
  color: #5d6b7b;
  margin-bottom: 6px;
}

.re-onb-track {
  height: 6px;
  border-radius: 999px;
  background: #e7eef5;
  overflow: hidden;
}

.re-onb-track span {
  display: block;
  height: 100%;
  background: #155dfc;
  border-radius: inherit;
}

.re-onb-list {
  list-style: none;
  margin: 0;
  padding: 4px 8px 8px;
  max-height: min(46vh, 420px);
  overflow: auto;
}

.re-onb-step {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 8px;
  border-radius: 12px;
}

.re-onb-step.current {
  background: #f3f7ff;
}

.re-onb-step.done .re-onb-step-title {
  color: #6b7280;
  text-decoration: line-through;
}

.re-onb-check {
  width: 22px;
  height: 22px;
  margin-top: 1px;
  border-radius: 50%;
  border: 1.5px solid #c5d0dc;
  background: #fff;
  color: #fff;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 0;
}

.re-onb-check.on {
  background: #16a34a;
  border-color: #16a34a;
}

.re-onb-step-body {
  min-width: 0;
  flex: 1 1;
}

.re-onb-step-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.3;
}

.re-onb-badge {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #8a6a12;
  background: #fff5d9;
  border-radius: 999px;
  padding: 2px 6px;
}

.re-onb-badge.group {
  color: #155dfc;
  background: #e8f0ff;
}

.re-onb-go {
  border: 0;
  background: transparent;
  color: #155dfc;
  font-size: 12px;
  font-weight: 800;
  padding: 4px 2px 0;
}

.re-onb-later-toggle {
  width: calc(100% - 16px);
  margin: 0 8px 8px;
  border: 0;
  background: #f7f9fb;
  color: #3b4c5b;
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  display: flex;
  align-items: center;
}

.re-onb-success {
  margin: 0 14px 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #e9f8ef;
}

.re-onb-success strong {
  display: block;
  font-size: 13px;
  margin-bottom: 2px;
}

.re-onb-card-foot {
  justify-content: space-between;
  padding: 0 14px 12px;
}

@media (max-width: 640px) {
  .re-onb {
    right: 12px;
    left: 12px;
    bottom: 12px;
    width: auto;
  }

  .re-onb-list {
    max-height: 38vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/onboarding/SetupGuide.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".re-onb {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 1045;\n  width: min(380px, calc(100vw - 24px));\n  font-family: inherit;\n  color: #182230;\n}\n\n.re-onb * {\n  box-sizing: border-box;\n}\n\n.re-onb-launcher,\n.re-onb-hide,\n.re-onb-check,\n.re-onb-go,\n.re-onb-textbtn,\n.re-onb-later-toggle {\n  font: inherit;\n  cursor: pointer;\n}\n\n.re-onb-launcher {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 0;\n  border-radius: 999px;\n  padding: 10px 14px 10px 10px;\n  background: #155dfc;\n  color: #fff;\n  box-shadow: 0 10px 28px rgba(21, 93, 252, 0.28);\n}\n\n.re-onb-launcher-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.18);\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n}\n\n.re-onb-launcher-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.15;\n}\n\n.re-onb-launcher-copy strong {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.re-onb-launcher-copy span {\n  font-size: 11px;\n  opacity: 0.88;\n}\n\n.re-onb-hint,\n.re-onb-card {\n  background: #fff;\n  border: 1px solid #e4eaf0;\n  border-radius: 16px;\n  box-shadow: 0 16px 40px rgba(24, 34, 48, 0.14);\n}\n\n.re-onb-card .re-onb-hint {\n  box-shadow: none;\n  background: #f4f7ff;\n  border-color: #d9e4fb;\n}\n\n.re-onb-hint {\n  margin-bottom: 10px;\n  padding: 14px 14px 12px;\n}\n\n.re-onb-hint-kicker {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #155dfc;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.re-onb-hint h3 {\n  margin: 0 0 6px;\n  font-size: 15px;\n  line-height: 1.3;\n}\n\n.re-onb-hint p,\n.re-onb-step p,\n.re-onb-success p {\n  margin: 0;\n  color: #5d6b7b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.re-onb-hint-actions,\n.re-onb-card-foot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.re-onb-textbtn {\n  border: 0;\n  background: transparent;\n  color: #5d6b7b;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 2px;\n}\n\n.re-onb-textbtn.primary {\n  color: #155dfc;\n}\n\n.re-onb-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 14px 10px;\n}\n\n.re-onb-card-head h2 {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.25;\n}\n\n.re-onb-card-head p {\n  margin: 2px 0 0;\n  color: #5d6b7b;\n  font-size: 12px;\n}\n\n.re-onb-iconbtn {\n  border: 0;\n  background: #f3f6f8;\n  color: #3b4c5b;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  flex: 0 0 auto;\n}\n\n.re-onb-progress {\n  padding: 0 14px 8px;\n}\n\n.re-onb-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  font-weight: 700;\n  color: #5d6b7b;\n  margin-bottom: 6px;\n}\n\n.re-onb-track {\n  height: 6px;\n  border-radius: 999px;\n  background: #e7eef5;\n  overflow: hidden;\n}\n\n.re-onb-track span {\n  display: block;\n  height: 100%;\n  background: #155dfc;\n  border-radius: inherit;\n}\n\n.re-onb-list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 8px 8px;\n  max-height: min(46vh, 420px);\n  overflow: auto;\n}\n\n.re-onb-step {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  padding: 8px;\n  border-radius: 12px;\n}\n\n.re-onb-step.current {\n  background: #f3f7ff;\n}\n\n.re-onb-step.done .re-onb-step-title {\n  color: #6b7280;\n  text-decoration: line-through;\n}\n\n.re-onb-check {\n  width: 22px;\n  height: 22px;\n  margin-top: 1px;\n  border-radius: 50%;\n  border: 1.5px solid #c5d0dc;\n  background: #fff;\n  color: #fff;\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n  padding: 0;\n}\n\n.re-onb-check.on {\n  background: #16a34a;\n  border-color: #16a34a;\n}\n\n.re-onb-step-body {\n  min-width: 0;\n  flex: 1;\n}\n\n.re-onb-step-title {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  font-size: 13.5px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.re-onb-badge {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #8a6a12;\n  background: #fff5d9;\n  border-radius: 999px;\n  padding: 2px 6px;\n}\n\n.re-onb-badge.group {\n  color: #155dfc;\n  background: #e8f0ff;\n}\n\n.re-onb-go {\n  border: 0;\n  background: transparent;\n  color: #155dfc;\n  font-size: 12px;\n  font-weight: 800;\n  padding: 4px 2px 0;\n}\n\n.re-onb-later-toggle {\n  width: calc(100% - 16px);\n  margin: 0 8px 8px;\n  border: 0;\n  background: #f7f9fb;\n  color: #3b4c5b;\n  border-radius: 10px;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: left;\n  display: flex;\n  align-items: center;\n}\n\n.re-onb-success {\n  margin: 0 14px 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: #e9f8ef;\n}\n\n.re-onb-success strong {\n  display: block;\n  font-size: 13px;\n  margin-bottom: 2px;\n}\n\n.re-onb-card-foot {\n  justify-content: space-between;\n  padding: 0 14px 12px;\n}\n\n@media (max-width: 640px) {\n  .re-onb {\n    right: 12px;\n    left: 12px;\n    bottom: 12px;\n    width: auto;\n  }\n\n  .re-onb-list {\n    max-height: 38vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
